
import { useMutation } from '@tanstack/react-query';
import { resetPasswordApi } from './auth.api';


export const useResetPasswordMutation = () => {
  return useMutation({
    mutationFn: ({ resetKey, password }: { resetKey: string; password: string }) =>
      resetPasswordApi(resetKey, password),
  });
};